<script>
export default {
    name: "Footer",
    data() {
        return {
            menu: [
                [
                    { text: 'About 440ME', url: '/about' },
                    { text: 'Contact Us', url: '/contactUs' },
                ],
                [
                    { text: 'Shipping', url: '/shopping' },
                    { text: 'Return Policy', url: '/returnPolicy' },
                    { text: 'Start a Return', url: '/startReturn' },
                ],
                [
                    { text: 'FAQ', url: '/FAQ' },
                    { text: 'Legal & Privacy', url: '/legalPrivacy' },
                    // { text: 'Accessibility', url: '/Accessibility' },
                    { text: 'Press', url: '' },
                ],
            ]
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="footer">
        <div class="in">
            <div class="menu" v-for="(item, index) in menu" :key="index">
                <div class="item" v-for="(_item, _index) in item" :key="_index">
                    <router-link class="link" :to="_item.url">{{_item.text}}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.footer{
    padding: 0 20px;
    height: 185px;
    background: #fff;
    .in{
        max-width: 1400px;
        border-top: 1px solid #ccc;
        margin: 0 auto;
        padding: 30px 16px 0;
        display: flex;
        .menu{
            font-size: 12px;
            margin-right: 130px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .item{
                margin-bottom: 20px;
                line-height: 2;
                border-bottom: 1px solid transparent;
                cursor: pointer;
                &:hover{
                    border-bottom-color: #777;
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        height: auto;
        padding: 0 .25rem;
        .in{
            display: block;
            padding: .34rem 0;
            border-top: 1px solid #999;
            .menu{
                display: block;
                margin: 0;
                font-size: .2rem;
                &:last-child{
                    .item{
                        &:last-child{
                            border-bottom: none;
                        }
                    }
                }
                .item{
                    border-bottom: 1px solid #cccccc;
                    margin: 0;
                    &:hover{
                        border-bottom-color: #cccccc;
                    }
                    a{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: .65rem;
                        line-height: .65rem;
                        &::after{
                            content: "";
                            display: block;
                            width: .1rem;
                            height: .1rem;
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            transform: rotate(45deg) translate(-50%, 50%);
                        }
                    }
                }
            }
        }
    }
}
</style>